import { render, staticRenderFns } from "./RulesInfos.vue?vue&type=template&id=6e6af098&scoped=true&"
import script from "./RulesInfos.vue?vue&type=script&lang=js&"
export * from "./RulesInfos.vue?vue&type=script&lang=js&"
import style0 from "./RulesInfos.vue?vue&type=style&index=0&id=6e6af098&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e6af098",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VChip,VIcon,VProgressLinear,VTooltip})
